const SCREEN_NAMES = {
  'pre-campaign': 'mm-early',
  home: 'mm-home-screen',
  'claim-success': 'mm-code',
  'claim-failed': 'mm-allclaimed',
  'code-not-working': 'mm-help',
  'campaign-ended': 'mm-end',
  terms: 'mm-termsconditions',
  'device-notice': 'mm-device-notice',
  'rotate-device': 'mm-rotate-device',
};

// Since the app has no router, so every screen shares one URL.
// GA4 derives the page path from page_location, so a synthetic one is sent per screen.
// The automatic page_view is disabled in index.html via send_page_view:false,
// so this is the only source of page views.
export function trackPageView(screen) {
  const name = SCREEN_NAMES[screen] || screen;

  window.gtag?.('event', 'page_view', {
    page_title: name,
    page_location: `${window.location.origin}/${name}`,
  });
}
